// extracted by mini-css-extract-plugin
module.exports = {"SArticleImage":"Kulturarrangement_SArticleImage__ygV3q","STextContainer":"Kulturarrangement_STextContainer__E1Use","SIngress":"Kulturarrangement_SIngress__6yvh9"};